export function getDarkLogoUrl(
  fileName?: string,
  fallback?: string,
): string | undefined {
  if (!fileName) return fallback;

  const ext = fileName.split('.').pop();
  const darkLogo = ext ? `/static/branding/dark-logo.${ext}` : undefined;

  return darkLogo ?? fallback;
}
